<template>
  <div>
    <banner />
    <div class="main-content" v-loading="loading">
      <div class="model-name">产业合作</div>
      <div class="model-name-en">Industry Cooperation</div>
      <div class="tab-buttons">
        <div class="tab-button" :class="activeTab == item.id ? 'tab-button-active':''" @click="tabClick(item)"
          v-for="item in tabBtns" :key="item.id">{{item.typeName}}</div>
      </div>
      <div class="hotspot-list" v-if="activeItem">
        <el-row :gutter="10">
          <el-col :span="7" :offset="1" v-for="(item, index) in activeItem.articleDetailList" :key="index">
            <div class="hotspot-item">
              <div class="hotspot-item-time">{{parseTime(item.createTime, '{y}-{m}-{d}')}}</div>
              <div class="hotspot-item-name more-text" @click="goArticle(item)">{{item.title}}</div>
              <div class="hotspot-item-desc more-t-2">{{item.brief}}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import {
  loadYxTitle
} from '@/api/api'
import {
  parseTime
} from '@/utils'
import Banner from "../../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      activeTab: -1,
      activeItem: null,
      tabBtns: [
        // {
        //   typeName: '产业招商'
        // },
        // {
        //   typeName: '微生态招商'
        // }
      ],
      loading: false,
      hotspotList: [
        {
          time: '2020.8.20',
          name: '自然教育营地，最直观、生动的生态课堂！',
          desc: '在传统的学科教育无法满足学生全方位、综合性发展需求的今天，教育+旅游的结合形成了双产业的消费升级。近几年'
        }
      ]
    };
  },
  created() {
    
  },
  mounted() {
    this.loadData()
  },
  methods: {
    parseTime,
    tabClick(item) {
      this.activeTab = item.id
      this.activeItem = item
    },
    loadData() {
      loadYxTitle().then(res => {
        if(res.content) {
          var info = res.content.find(item => {
            return item.titleType == 3
          })
          if(info && info.articleTypeList) {
            this.tabBtns = info.articleTypeList
            if(info.articleTypeList.length > 0) {
              this.activeTab = info.articleTypeList[0].id
              this.activeItem = info.articleTypeList[0]
            }
          }
        }
      })
    },
    goArticle(item) {
      this.$router.push({
        name: 'article',
        params: {
          ...item
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/color.scss';

.hotspot-item {
  height: 180px;
  .hotspot-item-time {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    color: #999999;
    margin-bottom: 14px;
  }
  .hotspot-item-name {
    line-height: 24px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-bottom: 18px;
    cursor: pointer;
  }
  .hotspot-item-desc {
    padding-top: 20px;
    border-top: 1px solid #ECECEC;
    line-height: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    color: #999999;
  }
}
</style>